goog.provide("shadow.js.shim.module$dayjs$locale$id");
goog.provide("module$shadow_js_shim_module$dayjs$locale$id");
shadow.js.shim.module$dayjs$locale$id = shadow.js.nativeProvides["dayjs/locale/id"] = require("dayjs/locale/id");
module$shadow_js_shim_module$dayjs$locale$id.default = shadow.js.shim.module$dayjs$locale$id;
